import { render, staticRenderFns } from "./SessionCreateModal.vue?vue&type=template&id=04b77edc&scoped=true"
import script from "./SessionCreateModal.vue?vue&type=script&lang=js"
export * from "./SessionCreateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b77edc",
  null
  
)

export default component.exports